import React, { Component } from 'react';

const GooglePlayLogo = (props) => {
	return (
		<div class="google_play_logo mod_align_center">
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<g>
					<path fill="#00C6FF" d="M7.53,5.26C7.3,5.5,7.17,5.88,7.17,6.36v17.28c0,0.48,0.13,0.86,0.36,1.1l0.06,0.06l9.68-9.68V15v-0.11
		L7.59,5.21L7.53,5.26z"/>
					<path fill="#FFCA00" d="M20.49,18.34l-3.23-3.23V15v-0.11l3.23-3.23l0.07,0.04l3.82,2.17c1.09,0.62,1.09,1.64,0,2.26l-3.82,2.17
						L20.49,18.34z"/>
					<path fill="#F3314A" d="M20.56,18.3l-3.3-3.3l-9.74,9.74c0.36,0.38,0.95,0.43,1.62,0.05L20.56,18.3"/>
					<path fill="#00F076" d="M20.56,11.7L9.15,5.22C8.48,4.84,7.89,4.88,7.53,5.26L17.26,15L20.56,11.7z"/>
				</g>
			</svg>

		</div>
	)
}

export default GooglePlayLogo;